<template>
  <div class="containerBox"  ref="box">
    <!--  顶部导航  -->
    <nav-bar />
    <div class="pageBox container">
      <div class="pageBox_left">
        <div class="breadCrumbs"><span @click="goHome">首页</span> > <span @click="getNews">新闻中心</span> > <span>新闻详情</span></div>
        <div class="pageBox_left_title">{{ detail?.title ?? '' }}</div>
        <div class="time">2022-05-11 07:53:11</div>
        <div class="line"></div>
        <div class="richMl" v-html="detail?.htmlContent ?? ''"></div>
<!--        <div class="line"></div>-->
      </div>
      <div class="pageBox_right">
        <div class="pageBox_right_title">近期资讯</div>
        <div class="pageBox_right_item" v-for="(item, index) in list" :key="index" @click="goDetail(item.articleId)">
          <img :src="item.coverImgUrl" alt="">
          <div class="pageBox_right_item_title">{{ item.title }}</div>
          <div class="pageBox_right_item_time">{{ item.createTime }}</div>
          <div class="pageBox_right_item_line"></div>
        </div>
        <div class="pageBox_right_bot">总部 | 山东聊城</div>
        <div class="tel">电话：4001368360</div>
        <div class="tel">地址：聊城市高唐县经济开发区商务中心</div>
        <div class="tel">网址：www.hmmwuliu.net</div>
      </div>
    </div>
    <!--  悬浮按钮  -->
    <fix-anchor @goBottom="goBottom" :box="$refs['box']" />
  </div>
</template>

<script>
import NavBar from '@/components/nav-bar.vue'
import FixAnchor from '@/components/fix-anchor.vue'
export default {
  name: "NewsDetail",
  components: {
    NavBar,
    FixAnchor
  },
  data() {
    return{
      list: [],
      detail: {}
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background-color: #F5F7FA')
  },
  created() {
    this.getDetail(this.$route.query.id)
    this.getList()
  },
  methods: {
    /**
     * @description: 页面滚动到顶部
     * @author: 书童
     */
    goBottom() {
      let top = this.$refs.box.offsetHeight, scrollTop = document.documentElement.scrollTop, clientHeight = document.documentElement.clientHeight
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = scrollTop += 50
        if (top <= (scrollTop + clientHeight)) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    /**
     * @description: 跳转首页
     * @author: 书童
     */
    goHome() {
      window.location.href = 'https://yswy.test.hmmwuliu.net/m/ws/'
    },
    getNews() {
      this.$router.push({
        name: 'newslist'
      })
    },
    /**
     * @description: 跳转详情
     * @author: 书童
     */
    goDetail(id) {
      this.$router.replace({
        path: '/newsdetail',
        query: {
          id
        }
      })
      this.$router.go(0)
    },
    /**
     * @description: 获取新闻详情
     * @author: 书童
     */
    getDetail(id) {
      this.$axios.get(`/public/appArticle/${id}`).then(res => {
        if (res.data.code === 0) {
          this.detail = res.data.data
        }
      })
    },
    /**
     * @description: 获取新闻列表
     * @author: 书童
     */
    getList() {
      this.$axios.get(`/public/appArticle/site/page?size=2&current=1&articleType=4`).then(res => {
        if (res.data.code === 0) {
          this.list = res.data.data.records
        }
      })
    },
  },
  mounted() {
    if (this.$public.isMobile()) {
      window.location.href = `http://hmmwuliu.net/common/ws-m/newsDetail.html?id=${this.$route.query.id}`
    }
    this.$forceUpdate()

  }
}
</script>

<style scoped lang="scss">
.pageBox{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-top: 70px;
  box-sizing: border-box;
  .pageBox_left{
    width: 864px;
    margin-right: 100px;
    .breadCrumbs{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #999999;
      line-height: 22px;
      margin-bottom: 20px;
      span{
        cursor: pointer;
      }
    }
    .pageBox_left_title{
      font-size: 36px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #000000;
      line-height: 50px;
    }
    .time{
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #999999;
      line-height: 25px;
      margin-top: 20px;
      margin-bottom: 40px;
    }
    .line{
      width: 864px;
      height: 4px;
      background: #e8ebee;
      margin: 40px 0;
    }
    .richMl{
      width: 864px;
      text-align: left;
      ::v-deep img{
        max-width: 100%;
      }
    }
  }
  .pageBox_right{
    width: 236px;
    .pageBox_right_title{
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      text-align: LEFT;
      color: #999999;
      line-height: 25px;
    }
    .pageBox_right_item{
      overflow: hidden;
      width: 100%;
      &>img{
        display: block;
        width: 236px;
        height: 120px;
        margin-top: 23px;
      }
      .pageBox_right_item_title{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #333333;
        line-height: 22px;
        margin-top: 19px;
        margin-bottom: 13px;
      }
      .pageBox_right_item_time{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: LEFT;
        color: #999999;
        line-height: 22px;
        margin-bottom: 24px;
      }
      .pageBox_right_item_line{
        width: 100%;
        height: 1px;
        background: #e8ebee;
      }
    }
  }
  .pageBox_right_bot{
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: #333333;
    line-height: 22px;
    margin: 20px 0px;
  }
  .tel{
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: LEFT;
    color: #666666;
    line-height: 20px;
    margin-bottom: 12px;
  }
}
</style>